// extracted by mini-css-extract-plugin
module.exports = {"container":"CardTextContainer_container__MdHLV","hidden":"CardTextContainer_hidden__qiDKx","description":"CardTextContainer_description___gc9g"};